import { __ } from '@wordpress/i18n'
import { useContext } from 'react';
import SbUtils from '../../../../Utils/SbUtils';
import SettingsScreenContext from '../../../Context/SettingsScreenContext';
import SelectSourcesSection from "../../CreationProcess/SelectSourcesSection";

const ManageSource = ( props ) => {
    const {
        sbCustomizer,
        editorNotification,
        editorConfirmDialog,
        sources,
        sourcesCount,
        freeRet,
        editorTopLoader
    } = useContext( SettingsScreenContext) ;

    /**
     * Build the delete confirmation content based on impact data
     * Returns structured content object for better dialog presentation
     */
    const buildDeleteContent = ( impact ) => {
        if ( impact.feeds_count === 0 ) {
            return {
                intro: __( 'This source is not used by any feeds.', 'sb-customizer' ),
                outro: __( 'Are you sure you want to delete it?', 'sb-customizer' )
            };
        }

        // Build feeds list
        const items = impact.feeds.map( feed => feed.name );
        const moreCount = impact.has_more ? impact.feeds_count - impact.feeds.length : 0;
        const feedWord = impact.feeds_count === 1 ? __( 'feed', 'sb-customizer' ) : __( 'feeds', 'sb-customizer' );

        return {
            intro: __( 'This source is used by', 'sb-customizer' ) + ' ' + impact.feeds_count + ' ' + feedWord + ':',
            items: items,
            moreCount: moreCount,
            warning: __( 'If you delete this source, these feeds will no longer retrieve new reviews from it.', 'sb-customizer' ),
            outro: __( 'Are you sure you want to continue?', 'sb-customizer' )
        };
    }

    /**
     * Show delete confirmation dialog with impact information
     */
    const showDeleteConfirmation = ( source, impact ) => {
        const confirmDialogInfo = {
            active : true,
            heading : `${ __('Delete ', 'sb-customizer') + '"'+source.name +'"?'  }`,
            content : buildDeleteContent( impact ),
            confirm : {}
        };

        const notificationsContent = {
            success : {
                icon : 'success',
                text : __( 'Source Deleted!', 'sb-customizer' )
            }
        };

        confirmDialogInfo.confirm.onConfirm = () => {
            const formData = {
                action : 'sbr_feed_saver_manager_delete_source',
                sourceID : source.id,
                sourceAccountID : source.account_id,
                sourceProvider : source.provider
            }
            SbUtils.ajaxPost(
                sbCustomizer.ajaxHandler,
                formData,
                ( data ) => { //Call Back Function
                    sources.setSourcesList( data.sourcesList )
                    if (data?.sourcesCount !== undefined) {
                        sourcesCount.setSourcesNumber( data.sourcesCount )
                    }
                    if (data?.freeRetrieverData) {
                        freeRet.setFreeRetrieverData(data?.freeRetrieverData)
                    }
                },
                editorTopLoader,
                editorNotification,
                notificationsContent
            )
        }
        editorConfirmDialog.setConfirmDialog( confirmDialogInfo )
    }

    /**
     * Fetch source impact and show delete confirmation
     */
    const deleteSource = ( source ) => {
        // First fetch the impact data
        const formData = {
            action : 'sbr_feed_saver_manager_get_source_impact',
            sourceAccountID : source.account_id
        }

        SbUtils.ajaxPost(
            sbCustomizer.ajaxHandler,
            formData,
            ( response ) => {
                // Show confirmation dialog with impact data
                const impact = response.data || { feeds_count: 0, feeds: [], has_more: false };
                showDeleteConfirmation( source, impact );
            },
            editorTopLoader,
            null,
            null
        )
    }


    return (
        <>
            <SelectSourcesSection
                context='settingspage'
                deleteSource={ ( source ) => {
                    deleteSource( source )
                } }
            />
        </>
    )
}

export default ManageSource;